<template>
  <div class="border-b-[0.75px]">
    <button
      :aria-label="title"
      class="link uppercase font-bold w-full text-left flex justify-between items-center lg:text-2xl"
      @click="isActive = !isActive"
    >
      <span class="inline-block py-30">{{ title }}</span>
      <ResponsiveSpriteSymbol
        :name="isOpen ? 'minus' : 'plus'"
        class="size-[14px] lg:size-20"
      />
    </button>

    <Collapse :when="isOpen">
      <div>
        <slot />
      </div>
    </Collapse>
  </div>
</template>

<script lang="ts" setup>
import { Collapse } from 'vue-collapsed'

const props = defineProps<{
  title: string
  alwaysOpen?: boolean
}>()

const isActive = ref(false)

const isOpen = computed<boolean>(() => props.alwaysOpen || isActive.value)
</script>
